// "Spot the Slip" expansion — FOOD theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_FOOD = [
  ["La zuppa sta molto calda, aspetta.", "La zuppa è molto calda, aspetta.", "essere-stare",
    "Temperature of a thing uses essere in Italian → è calda.", "essere-vs-stare"],
  ["Il pollo è ancora crudo dentro.", "Il pollo è ancora crudo dentro.", "essere-stare",
    "Trap check: a current condition of food uses essere. (Already correct!)", "essere-vs-stare"],
  ["Questa pasta è deliziosa, il mio piatto preferito.", "Questa pasta è deliziosa, il mio piatto preferito.", "essere-stare",
    "Trap check: a defining quality of the dish uses essere. (Already correct!)", "essere-vs-stare"],
  ["Ho un padella nuova.", "Ho una padella nuova.", "gender",
    "Padella is feminine → una padella.", "gender-of-nouns"],
  ["La riso è pronto.", "Il riso è pronto.", "gender",
    "Riso is masculine → il riso.", "gender-of-nouns"],
  ["Le patatine fritti sono buone.", "Le patatine fritte sono buone.", "agreement",
    "Fritte must agree with the feminine plural patatine.", "adjective-agreement"],
  ["Mi piace le banane mature.", "Mi piacciono le banane mature.", "piacere",
    "The verb agrees with the thing liked; plural bananas → piacciono.", "piacere-and-similar-verbs"],
  ["A me piacciono il formaggio stagionato.", "A me piace il formaggio stagionato.", "piacere",
    "One singular thing liked (the cheese) → piace.", "piacere-and-similar-verbs"],
  ["Vorrei una tazza da caffè, per favore.", "Vorrei una tazza di caffè, per favore.", "preposition",
    "Content uses di (a cup of coffee); da would mean a coffee-cup type.", "di-vs-da"],
  ["Il sapore di il sugo è ottimo.", "Il sapore del sugo è ottimo.", "articulated-prep",
    "di + il contracts to del.", "preposition-contractions"],
  ["Il sale? Passa a me, per favore.", "Il sale? Passamelo, per favore.", "pronoun-order",
    "Attach indirect + direct together: passa + me + lo → passamelo.", "object-pronouns"],
  ["Ieri cucinavo una lasagna per tutta la famiglia.", "Ieri ho cucinato una lasagna per tutta la famiglia.", "passato-imperfetto",
    "A single, completed cooking event takes the passato prossimo.", "passato-prossimo-vs-imperfetto"],
  ["Quante mele vuoi? Voglio tre.", "Quante mele vuoi? Ne voglio tre.", "ci-ne",
    "With a quantity use ne ('of them') → ne voglio tre.", "ci-and-ne"],
  ["Voglio che la zuppa ha meno sale.", "Voglio che la zuppa abbia meno sale.", "congiuntivo",
    "A wish about the dish (volere che) triggers the subjunctive → abbia.", "congiuntivo-presente"],
  ["Cerco un ristorante che serve cibo vegano.", "Cerco un ristorante che serva cibo vegano.", "congiuntivo",
    "An as-yet-unknown place you're looking for triggers the subjunctive → serva.", "congiuntivo-presente"],
];
